import { useContext } from 'react';

import { isNotDefined } from '@enterprise/core';

import { PaginationContext } from '#pagination/context/utilities/pagination.context';

/**
 * Custom React hook to access the `set` method from the PaginationContext store.
 *
 * @throws {Error} Throws an error if the PaginationContext store is not found.
 * @returns The `set` method from the PaginationContext store, used to update pagination state.
 */
export const usePaginationStoreSet = () => {
  const store = useContext(PaginationContext);

  if (isNotDefined(store)) {
    throw new Error('Store not found');
  }

  return store.set;
};
